import { createContext } from "react";

export type ModalsType = "edit-profile";

interface IModalContext {
  activeModal: string;
  closeModal: () => void;
  openModal: (modal?: ModalsType) => void;
  selectWalletModalState: boolean;
  setSelectWalletModalState: (state: boolean) => void;
  closeSelectWalletModal: () => void;
  openSelectWalletModal: () => void;
}

export const ModalContext = createContext<IModalContext>({} as IModalContext);
